export * from './src/stores-catalog-v3-brand-brands-v-3.meta.js';
